export const questions = {
    "quizTitle": "Construcția navei. Vitalitate – CLASA A",
    "quizSynopsis": "Model Construcția navei. Vitalitate · 30 min · minim 21/30 (barem 7)",
    "progressBarColor": "#9de1f6",
    "nrOfQuestions": "202",
    "examConfig": {
        "personnelCategory": "CLASA A",
        "timeMinutes": 30,
        "passPercent": 70,
        "minCorrect": 21,
        "barem": 7,
        "modelName": "Construcția navei. Vitalitate",
        "sections": [
            {
                "id": "Constructia navei",
                "label": "Construcția navei",
                "count": 24,
                "difficulty": 1
            },
            {
                "id": "Vitalitate",
                "label": "Vitalitate",
                "count": 6,
                "difficulty": 1
            }
        ],
        "totalQuestions": 30
    },
    "appLocale": {
        "landingHeaderText": "<questionLength> Intrebari",
        "question": "Intrebare",
        "startQuizBtn": "Incepe",
        "resultFilterAll": "Toate",
        "resultFilterCorrect": "Correct",
        "resultFilterIncorrect": "Incorect",
        "prevQuestionBtn": "Inapoi",
        "nextQuestionBtn": "Inainte",
        "multipleSelectionTagText": "Selectie multipla",
        "resultPageHeaderText": "Ai terminat. Ai <correctIndexLength> raspunsuri corecte din <questionLength> total.",
        "pickNumberOfSelection": "Alege <numberOfSelection>",
        "marksOfQuestion": "(<marks> puncte)"
    },
    "questions": [
        {
            "question": "1. Ce este opera vie?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) partea permanent submersă a navei în condiţii normale de plutire",
                "b) partea permanent emersă a navei în condiţii normale de plutire",
                "c) nivelul de plutire al navei la linia de apă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "2. Ce este opera moartă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nivelul de plutire al navei la linia de apă",
                "b) partea permanent emersă a navei în condiţii normale de plutire",
                "c) partea permanent submersă a navei în condiţii normale de plutire"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "3. Ce este planul diametral al navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul vertical longitudinal care împarte nava în două părţi simetrice, tribord şi babord",
                "b) planul care împarte nava în două părţi, prova şi pupa",
                "c) planul care împarte nava în două părţi asimetrice, prova şi pupa"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "4. Ce este planul cuplului maestru?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul orizontal care desparte partea imersă de partea emersă a corpului navei",
                "b) planul transversal vertical care trece prin secţiunea maestră şi împarte corpul navei în două părţi simetrice, tribord şi babord",
                "c) planul transversal vertical care trece prin secţiunea maestră şi împarte corpul navei în două părţi asimetrice, prova şi pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "5. Ce este planul plutirii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul orizontal care coincide cu suprafaţa liberă a apei liniştite şi împarte corpul navei în partea imersă şi partea emersă",
                "b) planul transversal vertical care trece prin secţiunea maestră şi împarte corpul navei în două părţi simetrice, tribord şi babord",
                "c) planul transversal vertical care trece prin secţiunea maestră şi împarte corpul navei în două părţi asimetrice, prova şi pupa"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "6. Cum este notat în calcule şi planuri pescajul navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) L",
                "b) D",
                "c) T"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "7. Cum se numeşte partea corpului navei aflată deasupra liniei de plutire?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) opera vie",
                "b) opera moartă",
                "c) carena"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "8. Cum se numeşte partea corpului navei aflată sub linia de plutire?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) opera vie",
                "b) opera moartă",
                "c) osatura"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "9. Deasupra liniei de plutire a navei se află",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) partea imersă",
                "b) partea emersă",
                "c) opera vie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "10. Sub linia de plutire a navei se află",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) partea imersă",
                "b) partea emersă",
                "c) rezerva de flotabilitate"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "11. Corpul navei este simetric faţă de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul cuplului maestru",
                "b) planul plutirii",
                "c) planul diametral"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "12. Partea din dreapta a unei nave este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tribordul",
                "b) babordul",
                "c) cuplu maestru"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "13. Partea din stânga a unei nave este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tribordul",
                "b) babordul",
                "c) teuga"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "14. Cum se numeste extremitatea anterioara a navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pupa",
                "b) prova",
                "c) dublu fund"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "15. Cum se numeste extremitatea posterioara a navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pupa",
                "b) prova",
                "c) pic prova"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "16. Cum se numeşte planul care împarte corpul navei în cele două părţi simetrice, tribord şi babord?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul cuplului maestru",
                "b) planul plutirii",
                "c) planul diametral"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "17. Cum se numeşte planul care împarte corpul navei în cele două părţi, prova şi pupa?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul cuplului maestru",
                "b) planul plutirii",
                "c) planul diametral"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "18. Cum se numeşte planul care separă partea imersă de partea emersă a corpului navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul cuplului maestru",
                "b) planul plutirii",
                "c) planul diametral"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "19. Care din planurile principale ale navei împarte nava in doua părţi, opera vie si opera moartă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul cuplului maestru",
                "b) planul plutirii",
                "c) planul diametral"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "20. Care dintre planurile principale de proiecţie coincide cu suprafaţa liberă a apei liniştite?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul cuplului maestru",
                "b) planul de bază",
                "c) planul plutirii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "21. Cum se numeşte planul principal de proiecţie vertical longitudinal, perpendicular pe planul secţiunii maestre?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul cuplului maestru",
                "b) planul diametral",
                "c) planul plutirii"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "22. Cum se numeşte planul principal de proiecţie vertical-transversal, care trece prin secţiunea maestră?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) planul cuplului maestru",
                "b) planul diametral",
                "c) planul plutirii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "23. Planul de bază intersectează, în general, corpul navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da, rezultând linia de plutire",
                "b) nu",
                "c) da, rezultând secţiunea maestră"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "24. Ce este flotabilitatea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proprietatea navei de a pluti la suprafaţa apei",
                "b) proprietatea navei de a se opune actiunii forţelor exterioare care tind să o încline şi de a reveni la poziţia iniţială",
                "c) proprietatea navei de a se mişca liberă pe suprafaţa mării"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "25. Rezerva de flotabilitate este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) volumul compartimentelor destinate mărfii",
                "b) totalitatea volumelor tancurilor de balast",
                "c) volumul corpului etanş situat deasupra liniei de plutire"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "26. Rezerva de flotabilitate este dată de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Înălţimea de construcţie a navei",
                "b) Înălţimea bordului liber",
                "c) pescajul navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "27. Ce este o societate de clasificare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o instituţie care are ca obiect de activitate supravegherea tehnică şi clasificarea navelor civile",
                "b) totalitatea cărţilor tehnice de clasificare a navelor civile",
                "c) asociaţia organelor de control tehnic al navelor, constituită din armatori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "28. Ce este stabilitatea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proprietatea navei de a pluti in condiţii normale, fără să se scufunde pe mare liniştită",
                "b) proprietatea navei de a reveni la poziţia iniţială de echilibru, după încetarea acţiunii forţei care a scos-o din această stare",
                "c) proprietatea navei de a se mişca cu o viteză determinată pe suprafaţa agitată a mării"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "29. Ce este manevrabilitatea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proprietatea navei de a executa uşor şi rapid diferite manevre şi evoluţii chiar şi într-un loc restrâns",
                "b) proprietatea navei de a se mişca cu o viteză determinată pe o anumită direcţie",
                "c) proprietatea navei de a pluti in condiţii normale pe apa mării"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "30. Giraţia unei nave este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proprietatea navei de a se deplasa cu o viteză determinată",
                "b) proprietatea navei de a-si schimba direcţia de deplasare sub influenţa cârmei, a maşinilor sau a efectului combinat al acestora",
                "c) proprietatea navei de a-şi menţine direcţia deplasării"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "31. Ce este stabilitatea de drum?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proprietatea navei de a se mişca cu o viteză determinată",
                "b) proprietatea navei de a-şi schimba direcţia mişcării",
                "c) proprietatea navei de a-şi menţine direcţia de marş, fără acţionarea cârmei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "32. Ce este nescufundabilitatea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proprietatea navei de a pluti in conditii normale",
                "b) proprietatea navei de a-şi păstra flotabilitatea şi stabilitatea în cazul inundării unuia sau mai multor compartimente",
                "c) proprietatea navei de a-si pastra sau de a-si schimba directia miscarii"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "33. În ce se măsoară viteza de marş in navigatia maritima?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in Newton (N)",
                "b) in noduri (Nd)",
                "c) in kilometri / ora (km/h)"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "34. Ce este deplasamentul navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) greutatea totală a navei complet echipate, inclusiv a mărfii şi/sau a balastului de la bord",
                "b) greutatea navei goale, fără combustibil şi rezerve",
                "c) greutatea mărfii şi/sau a balastului de la bord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "35. Ce este suprastructura?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o construcţie situată deasupra punţii principale, care nu se întinde pe toată lăţimea navei",
                "b) o construcţie situată deasupra punţii principale, care se întinde pe toată lăţimea navei",
                "c) o construcţie situată pe puntea principală, la prova navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "36. Ce este ruful?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o construcţie situată deasupra punţii principale, care nu se întinde pe toată lăţimea navei",
                "b) o construcţie situată deasupra punţii principale, care se întinde pe toată lăţimea navei",
                "c) o construcţie situată pe puntea etalon, la pupa navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "37. Ce se înscrie în certificatul de tonaj?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplasamentul navei",
                "b) pescajul navei",
                "c) tonajul brut si tonajul net al navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "38. În ce se măsoară tonajul brut?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în tone registru",
                "b) în tone",
                "c) în kilonewton"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "39. În ce se masoară tonajul net?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în tone",
                "b) în tone registru",
                "c) în kilonewton"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "40. Ce este tonajul brut?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) greutatea navei încărcate cu marfă",
                "b) volumul tuturor compartimentelor închise destinate transportului mărfurilor",
                "c) o mărime calculată convenţional, reprezentând volumul total al compartimentelor închise, inclusiv suprastructura"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "41. Ce este tonajul net?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) volumul tuturor compartimentelor interioare închise ale navei, inclusiv suprastructurile",
                "b) greutatea navei goale, dar cu rezervele de combustibil",
                "c) o mărime calculată convenţional, care reprezintă totalitatea spaţiilor de încărcare şi/sau de numărul de pasageri ce pot fi ambarcaţi"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "42. Unde se află etrava?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la pupa navei",
                "b) la prova navei",
                "c) la mijlocul navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "43. Unde se află etamboul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la pupa navei",
                "b) la prova navei",
                "c) la mijlocul navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "44. Selatura unei punţi este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) curbura convexă a punţii în plan diametral, de la centrul navei către borduri",
                "b) deschiderile din punţi pentru vizitarea diferitelor compartimente",
                "c) modul de prindere a capacelor de magazie pe puntea principală"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "45. Ce rol are selatura punţii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a menţine nava pe chilă dreaptă",
                "b) de a asigura scurgerea rapidă a apei de pe punţi",
                "c) de a împiedica scurgerea apei de pe punte spre bordaj"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "46. Ce se înţelege prin \"apendici\" ai corpului navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) elemente din structura interna a navei",
                "b) elemente constructive ale osaturii navei",
                "c) elemente constructive si funcţionale care ies în afara corpului navei, în partea imensă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "47. Care sunt \"apendicii\" navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) elicea, pana cârmei, chilele de ruliu, cavaleţii",
                "b) parapete, balustrăzile, brâiele, grătarele",
                "c) ferestre, hublouri, uşi metalice"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "48. Unde sunt amplasate chilele de ruliu?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe fundul navei, în dreptul chilei",
                "b) pe puntea principală, la prova şi la pupa",
                "c) în ambele borduri, perpendiculare şi continue pe curbura gurnei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "49. Ce sunt manevrele fixe?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parîmele vegetale şi sintetice pentru legarea navei la cheu",
                "b) parâmele metalice pentru consolidarea în plan longitudinal şi transversal a catargelor şi/sau a pontililor",
                "c) totalitatea parâmelor metalice folosite la amararea mărfii în magaziile navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "50. Ce sunt manevrele mobile?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parâmele vegetale şi/sau sintetice folosite la manevrarea velelor, vergilor, bigilor, tangoneţilor etc",
                "b) parâmele metalice pentru consolidarea în plan longitudinal şi transversal a catargelor şi/sau a pontililor",
                "c) parîmele vegetale şi sintetice pentru legarea navei la cheu"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "51. Ce este greementul navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) totalitatea catargelor unei nave",
                "b) totalitatea parâmelor metalice folosite la amararea mărfii în magaziile navei",
                "c) totalitatea manevrelor fixe şi mobile de la bordul unei nave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "52. Unde sunt amplasate coastele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) simetric, vertical pe bordajul navei, de la chilă până la puntea principală",
                "b) simetric, pe puntea principală, paralel cu chila, de la prova la pupa",
                "c) pe paiolul magaziilor de marfă, paralel cu chilele de ruliu"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "53. Unde se află gurna?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe fundul navei, în zona plată, dintr-un bord într-altul",
                "b) este porţiunea curbată de îmbinare a fundului plat cu bordajul navei",
                "c) este porţiunea de îmbinare a punţii principale cu bordajul navei, de la prova la pupa"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "54. Ce rol are elicea, la o navă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a asigura posibilitatea mişcării după o traiectorie stabilită şi de a modifica comandat direcţia de deplasare",
                "b) de a susţine arborii portelice situaţi între motorul principal şi tubul etambou",
                "c) de a asigura propulsia navei înspre înainte şi înapoi şi de-a o opri din deplasare"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "55. Ce rol are cârma, la o navă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a asigura posibilitatea mişcării după o traiectorie stabilită şi de a modifica comandat direcţia de deplasare",
                "b) de a susţine arborii portelice situaţi între motorul principal şi tubul etambou",
                "c) de a deplasa nava cu ajutorul forţei de propulsie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "56. Ce rol are tubul etambou, la o navă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a susţine pana cârmei când nava este pe doc",
                "b) de a sustine arborii portelice la trecerea etanşă a acestora în afara bordului",
                "c) de a asigura spargerea gheţii când se navigă în ape reci"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "57. Ce este lungimea maximă a unei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) distanţa măsurată în planul diametral, la linia de plutire de plină încărcare, între punctele de intersecţie ale acesteia cu linia etamboului şi cea a etravei",
                "b) distanţa măsurată în planul diametral, la linia de plutire de plină încărcare, între punctele de intersecţie ale acesteia cu axul cârmei şi linia etravei",
                "c) distanţa măsurată în planul diametral al navei, pe direcţia orizontală paralelă cu chila, între punctele extreme prova şi pupa ale navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "58. Ce este lungimea între perpendiculare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) distanţa măsurată în planul diametral, la linia de plutire de plină încărcare, între punctele de intersecţie ale acesteia cu linia etamboului şi cea a etravei",
                "b) distanţa măsurată în planul diametral, la linia de plutire de plină încărcare, între punctele de intersecţie ale acesteia cu axul cârmei şi linia etravei",
                "c) distanţa măsurată în planul diametral al navei, pe direcţia orizontală paralelă cu chila, între punctele extreme prova şi pupa ale navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "59. Ce este lungimea pe plutire de plină încărcare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) distanţa măsurată în planul diametral, la linia de plutire de plină încărcare, între punctele de intersecţie ale acesteia cu linia etamboului şi cea a etravei",
                "b) distanţa măsurată în planul diametral, la linia de plutire de plină încărcare, între punctele de intersecţie ale acesteia cu axul cârmei şi linia etravei",
                "c) distanţa măsurată în planul diametral al navei, pe direcţia orizontală paralelă cu chila, între punctele extreme prova şi pupa ale navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "60. Ce este pescajul mediu al navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) distanţa măsurată pe verticală, de la linia de bază până la punctul cel mai înalt al punţii principale",
                "b) distanţa măsurată pe verticală, de la linia plutirii până la linia punţii",
                "c) distanţa măsurată pe verticală, în dreptul cuplului maestru, de la planul liniei de bază, până la linia de plutire"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "61. Ce este înălţimea de construcţie a navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) distanţa masurată pe verticală, între planul de bază şi punctul de intersecţie al liniei punţii cu linia bordului în planul cuplului maestru",
                "b) distanţa măsurată pe verticală, între planul plutirii şi punctul de intersecţie al liniei punţii cu linia bordului, în planul cuplului maestru",
                "c) distanţa măsurată în planul cuplului maestru, între planul de bază şi planul plutirii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "62. Ce este înălţimea bordului liber al navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) distanţa măsurată pe verticală, între planul de bază şi punctul de intersecţie al liniei punţii cu linia bordului în planul cuplului maestru",
                "b) distanţa măsurată pe verticală, între planul plutirii şi punctul de intersecţie al liniei punţii cu linia bordului, în planul cuplului maestru",
                "c) distanţa măsurată în planul cuplului maestru, între planul de bază şi planul plutirii"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "63. Unde este amplasat picul prova?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) între etambou şi ultimul perete transversal etanş",
                "b) între invelişul exterior al fundului navei şi puntea dublului fund",
                "c) între etravă şi primul perete transversal etanş"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "64. Unde este amplasat picul pupa?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) între invelişul exterior al fundului navei şi puntea dublului fund",
                "b) între etambou şi ultimul perete transversal etanş",
                "c) între compartimenul maşini şi ultima magazie de marfă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "65. Ce este cofferdam-ul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un compartiment etanş de separare",
                "b) picul prova inclusiv puţul lanţului",
                "c) compartiment etanş sub magaziile de marfă, în care se pune balastul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "66. Ce sunt sarturile?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manevrele fixe ale navei, care susţin un catarg, pontil sau coloană în planul diametral, înspre prova",
                "b) manevrele fixe ale navei, care susţin un catarg, pontil sau coloană în plan transversal (în borduri)",
                "c) manevrele fixe ale navei, care susţin un catarg, pontil sau coloană înspre pupa şi lateral"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "67. Ce sunt straiurile?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manevrele fixe ale navei, care susţin un catarg, pontil sau coloană în planul diametral, înspre prova",
                "b) manevrele fixe ale navei, care susţin un catarg, pontil sau coloană în plan transversal (în borduri)",
                "c) manevrele fixe ale navei, care susţin un catarg, pontil sau coloană înspre pupa"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "68. Ce sunt pataraţinele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manevrele fixe ale navei, care susţin un catarg, pontil sau coloană în planul diametral, înspre prova",
                "b) manevrele fixe ale navei, care susţin un catarg, pontil sau coloană în plan transversal (în borduri)",
                "c) manevrele fixe ale navei, care susţin un catarg, pontil sau coloană înspre pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "69. Ce este osatura?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) structura de rezistenţă formată dintr-o placă dreaptă sau curbă rezemată, întărită cu bare şi elemente de legătură",
                "b) o reţea spaţială de bare drepte şi curbe, îmbinate între ele, care determină şi menţine formele geometrice ale corpului navei",
                "c) totalitatea planşeelor inferioare şi superioare din interiorul corpului navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "70. Ce este planşeul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) structura de rezistenţă formată dintr-o placă dreaptă sau curbă rezemată, întărită cu bare şi elemente de legatură",
                "b) o reţea spaţială de bare drepte şi curbe, îmbinate între ele, care determină şi menţine formele geometrice ale corpului navei",
                "c) totalitatea planşeelor inferioare şi superioare din interiorul corpului navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "71. Ce sunt construcţiile de rigidizare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) structura de rezistenţă formată dintr-o placă dreaptă sau curbă rezemată, întărită cu bare şi elemente de legatură",
                "b) o reţea spaţială de bare drepte şi curbe, îmbinate între ele, care determină şi menţine formele geometrice ale corpului navei",
                "c) totalitatea planşeelor inferioare şi superioare din interiorul corpului navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "72. Greementul reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) totalitatea pieselor confecţionate din lemn sau din metal şi care se numesc: catarge, arbori, ghiu, bompres",
                "b) totalitatea manevrelor fixe şi mobile de la bordul unei nave",
                "c) un stâlp vertical, aşezat în planul diametral al navei şi fixat de osatura de rezistenţă a navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "73. Arborada reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) totalitatea pieselor confecţionate din lemn sau din metal şi care se numesc: catarge, arbori, ghiu, bompres",
                "b) totalitatea manevrelor fixe şi curente de la bord, folosite pentru fixarea arborilor, susţinerea şi manevra vergilor şi a velelor",
                "c) un stâlp vertical, aşezat în planul diametral al navei şi fixat de osatura de rezistenţă a navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "74. Ce este un catarg?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) totalitatea pieselor confecţionate din lemn sau din metal şi care se numesc: catarge, arbori, ghiu, bompres",
                "b) totalitatea manevrelor fixe şi curente de la bord, folosite pentru fixarea arborilor, susţinerea şi manevra vergilor şi a velelor",
                "c) un stâlp vertical, aşezat în planul diametral al navei şi fixat de osatura de rezistenţă a navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "75. Catargul face parte din:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) greementul navei",
                "b) arborada navei",
                "c) instalaţia de evacuare a apelor uzate de la bord"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "76. Părţile componente ale unui catarg sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) călcâi, picior şi gabie",
                "b) coloana, gabierul, arboretul",
                "c) butuc, traversă şi crucetă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "77. Care este partea inferioară a unui catarg?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) gabierul",
                "b) coloana",
                "c) arboretul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "78. Care este parte superioară a unui catarg?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) gabierul",
                "b) coloana",
                "c) arboretul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "79. Care este partea de mijloc a unui catarg?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) gabierul",
                "b) coloana",
                "c) arboretul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "80. Cum se numeste vârful catargului, în limbaj marinăresc?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) butuc",
                "b) măr",
                "c) gabie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "81. Arboretul este partea superioară a catargului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) nu este un element al catargului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "82. Gabierul este partea de mijloc a unui catarg?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) nu este un element al catargului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "83. Coloana este partea inferioară a catargului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da",
                "b) nu",
                "c) nu este un element al catargului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "84. Ce este gabia?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) platforma coloanei catargului",
                "b) platforma gabierului catargului",
                "c) o manevră mobilă de întindere a americanului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "85. Ce este cruceta?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) platforma coloanei catargului",
                "b) platforma gabierului catargului",
                "c) o manevră mobilă de întindere a gaiului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "86. Cum se numeşte arborele înclinat fixat in prova navei, care se întâlneşte la navele cu vele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trinchet",
                "b) bompres",
                "c) artimon"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "87. Ce este verga?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un catarg simplu",
                "b) o traversa orizontala, incrucisata pe catarg",
                "c) o manevra curenta"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "88. Ce sunt ambarcaţiunile?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nave de transport pasageri cu clasa de navigaţie nelimitată",
                "b) nave mici şi foarte mici, care se deplasează pe apă cu propulsie proprie",
                "c) nave mici şi foarte mici, care se deplaseaza pe apă doar remorcate la ureche de alte nave"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "89. Ambarcaţiunile pot avea propulsie cu rame si vele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da",
                "b) nu",
                "c) ambarcaţiunile nu au propulsie proprie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "90. Cum se clasifică bărcile după felul propulsiei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu rame, vele, elice",
                "b) cu propulsie proprie şi fără propulsie proprie",
                "c) cu prova ascuţită şi cu prova dreaptă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "91. Cum se clasifică bărcile după numărul de rame?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mici, mijlocii şi mari",
                "b) 10+1, 8+1, 2 sau 4 rame",
                "c) 7+1, 5+1 sau 3+1"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "92. Cum se numeste structura de rezistenta a barcii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bordajul bărcii",
                "b) etrava bărcii",
                "c) osatura bărcii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "93. Cum se numesc coastele la bărci?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nervuri",
                "b) crevace",
                "c) turnicheti"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "94. Ce se află pe fundul bărcii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) gurna",
                "b) 1-2 orificii închise cu dopuri filetate din bronz sau aluminiu",
                "c) copastia"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "95. La ce servesc orificiile de pe fundul unei bărci?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la scoaterea prin ele a unui capăt de parâmă subţire pentru ancora de furtună",
                "b) la evacuarea apei când barca este scoasă din apă",
                "c) la introducerea prin ele a unui surub de fund"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "96. Cum sunt dispuse bancurile într-o barcă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) longitudinal",
                "b) suprapus",
                "c) transversal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "97. Cum sunt dispuse banchetele într-o barcă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) longitudinal",
                "b) suprapus",
                "c) transversal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "98. La ce folosesc bancurile?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe ele stau persoanele transportate in barcă",
                "b) pe ele stau cei care trag la rame",
                "c) pe ele sunt tancurile de apă potabilă, proviziile şi trusele de scule ale bărcii"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "99. La ce folosesc banchetele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe ele stau persoanele transportate cu barca",
                "b) pe ele stau marinarii cand trag la rame",
                "c) pe ele stau proviziile din barca"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "100. Unde stau persoanele transportate în barcă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la prova bărcii, pentru o asietă convenabilă",
                "b) pe banchetele bărcii, fără a incomoda vâslaşii",
                "c) pe bancurile bărcii, lângă fiecare vâslaş"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "101. O barcă poate fi puntată",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în prova şi/sau în pupa",
                "b) la centrul bărcii, sub toate bancurile",
                "c) lateral, pe toată lungimea, sub banchete"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "102. Saula \"ţin-te bine\" se întâlneşte la",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) barcile de serviciu",
                "b) barcile de salvare, bărci tip \"zodiac\"",
                "c) barcile de serviciu si barcile de salvare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "103. Ce este ghiordelul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un făraş din metal, lemn sau plastic, cu pereţii înalţi, pentru scos apa din barcă",
                "b) o găleată din metal, din lemn sau plastic",
                "c) un element din structura de rezistenţă a bărcii"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "104. Ce este ispolul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un făraş din metal, lemn sau plastic, cu pereţii înalţi, pentru scos apa din barcă",
                "b) o găleată metalică, din lemn sau plastic",
                "c) un element din structura de rezistenţă a bărcii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "105. Ce sunt barbetele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) găleţi din metal, lemn sau plastic",
                "b) socare de sizal sau sintetice, legate la prova şi pupa bărcii",
                "c) elemente hidrodinamice în afara corpului bărcii"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "106. Ce este o cange?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o prăjină cu lungimea de cel puţin 2 metri, care are montat un sistem de agăţare la unul din capete",
                "b) o ramă cu palma de dimensiuni mari, folosită şi drept cârmă de avarie",
                "c) un element din structura de rezistenţă a bărcii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "107. Bărcile care au prova şi pupa ascuţite se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) iole",
                "b) baleniere",
                "c) cuter"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "108. Cavaleţii sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) elemente din structura de rezistenţă a bărcii de salvare",
                "b) partea întărită a bărcii pe care se fixează motorul",
                "c) suporţi metalici sau din lemn, pe care se poziţionează barca atunci când este scoasă din apă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "109. Navele \"mineraliere\" sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nave de agrement",
                "b) nave pentru competiţii sportive",
                "c) nave de transport mărfuri solide în vrac"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "110. Navele \"tanc\" sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navele destinate transportului pasagerilor",
                "b) navele de luptă de mare tonaj, dar fără blindaje",
                "c) navele destinate transportului mărfurilor lichide în vrac"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "111. Navele \"cargou\" sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navele de pescuit oceanic",
                "b) navele destinate transportului mărfurilor generale",
                "c) navele de luptă de tonaj mediu, folosite şi pentru dragajul de mine"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "112. Proprietatea navei de a pluti în condiţii normale de exploatare se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stabilitate",
                "b) flotabilitate",
                "c) nescufundabilitate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "113. Proprietatea navei de a reveni la poziţia iniţială de echilibru, după încetarea acţiunii forţei care a scos-o din această stare se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stabilitate",
                "b) flotabilitate",
                "c) nescufundabilitate"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "114. Proprietatea navei de a-şi păstra flotabilitatea şi stabilitatea în cazul inundării unuia sau mai multor compartimente se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplasarea prin apă cu viteză constantă",
                "b) manevrabilitate",
                "c) nescufundabilitate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "115. Cum se numeşte proprietatea navei de a se mişca cu o viteză determinată?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplasare",
                "b) manevrabilitate",
                "c) giratie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "116. Cum se numeşte proprietatea navei de a-şi păstra direcţia mişcării?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplasare",
                "b) stabilitatea de drum",
                "c) giraţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "117. Proprietatea navei de a-si schimba direcţia de deplasare sub influenţa cârmei, a maşinilor sau a efectului combinat al acestora se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deplasare",
                "b) stabilitate de drum",
                "c) giraţie"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "118. Totalitatea greutăţilor ce se pot ambarca pe o navă, fără a depăşi pescajul maxim admis pentru zona respectivă reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) capacitatea de încarcare (deadweight)",
                "b) rezistenţa corpului la vibraţii în timpul marşului",
                "c) osatura dublului fund al navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "119. Capacitatea navei de a-şi păstra etanşeitatea şi de a nu se deforma sub acţiunea forţelor exterioare este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) capacitatea de încărcare",
                "b) rezistenţa corpului",
                "c) stabilitatea de drum"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "120. Viteza de un nod este egală cu",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1675 m/oră",
                "b) 1852 m/oră",
                "c) 1852 m/minut"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "121. Viteza în noduri se poate exprima în metri pe secundă prin",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) înmulţirea cu 5",
                "b) împărţirea la 5",
                "c) împărţirea la 2"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "122. Înclinarea navei în jurul axului longitudinal, datorită repartizării asimetrice a greutăţilor de la bord, a acţionării în marş a cârmei cu unghiuri mari sau a acţiunii continue a vântului, se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tangaj",
                "b) canarisire",
                "c) ruliu"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "123. Mişcarea oscilatorie a navei în plan transversal datorată acţiunii valurilor se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tangaj",
                "b) bandă",
                "c) ruliu"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "124. Înclinarea navei în jurul unui ax transversal, înspre prova sau înspre pupa se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) asietă",
                "b) tangaj",
                "c) ambardee"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "125. Mişcarea oscilatorie a navei în jurul unui ax transversal, datorită \"încălecării\" navei pe val se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ruliu",
                "b) tangaj",
                "c) asietă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "126. Când se spune despre o navă, că este canarisită?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) atunci când nava are pescajul prova mai mare decât pescajul pupa",
                "b) atunci când nava are pescajele prova şi pupa egale",
                "c) atunci când nava rămâne înclinată într-unul din borduri"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "127. Când se spune despre o navă că este aprovată?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) atunci când nava are pescajul prova mai mare decât pescajul pupa",
                "b) atunci când nava are pescajele prova şi pupa egale",
                "c) atunci când nava are pescajul pupa mai mare decât pescajul prova"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "128. Când se spune despre o navă că este apupată?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) atunci când nava are pescajul prova mai mare decât pescajul pupa",
                "b) atunci când pescajul pupa este mai mare decât pescajul prova",
                "c) atunci când nava rămâne înclinată într-unul din borduri"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "129. Când se spune despre o navă că are asietă zero?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) atunci când nava are pescajul prova mai mare decât pescajul pupa",
                "b) atunci când pescajul pupa este mai mare decât pescajul prova",
                "c) atunci când nava are pescajele prova şi pupa egale"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "130. Clasificarea navelor comerciale pe tipuri se face funcţie de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) natura mărfurilor transportabile cu acea navă",
                "b) zona de navigaţie",
                "c) pescajul maxim la linia de vară"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "131. Funcţie de pescaj, navele se pot clasifica în",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu pescaj mic, mediu şi mare",
                "b) cu pescaj de iarnă",
                "c) cu pescaj de vară"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "132. Există nave fără pescaj?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da, hovercraft-urile",
                "b) nu există",
                "c) sunt doar navele militare de transport trupe"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "133. Bulbul unei nave are rolul de a",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mări pescajul prova al navei",
                "b) reduce rezistenţa la înaintare şi mări stabilitatea de drum",
                "c) facilita ancorarea în ape cu adâncime mică"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "134. Zincurile de pe bordajul unei nave au rolul de a",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proteja corpul navei împotriva depunerilor planctonice",
                "b) proteja corpul navei împotriva ruginirii excesive",
                "c) proteja corpul navei împotriva corodării datorate curenţilor Foulcault"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "135. Montarea elicei unei nave în diuză pivotantă are rolul de a",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proteja elica şi mări manevrabilitatea navei",
                "b) oferi o mai bună inspecţie a elicei pe timpul funcţionării în regim de avarie",
                "c) da posibilitatea răsturnării mai rapide a motorului principal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "136. Funcţie de zona de navigaţie admisă, navele pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nave de pasageri, nave de transport, nave piscicole, nave tehnice, nave de servitute",
                "b) cu zonă de navigaţie nelimitată sau limitată",
                "c) nave civile si nave militare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "137. Navele de cabotaj pot naviga",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în orice zonă a lumii",
                "b) costier, între porturi apropiate, fără a efectua traversade",
                "c) numai pe fluvii, fără a ieşi în mare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "138. O navă este definită ca fiind",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un corp plutitor cu propulsie proprie sau nu, utilizată în scopul pentru care a fost construită",
                "b) un corp plutitor cu propulsie proprie sau nu, folosită în scopul pentru care a fost construită, respectiv militar, civil sau de cercetare construita,respectiv civil sau militar",
                "c) o construcţie complexă, amenajată şi echipată pentru a pluti şi a se deplasa pe apă sau sub apă, în scopuri civile, militare sau pentru cercetare"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "139. După modul de propulsie, navele pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) clasice, propulsate cu jet, cu zbaturi, cu aripi portante, hovercraft-uri etc",
                "b) cu unul sau două aparate propulsoare combinate",
                "c) cu bow thruster electric"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "140. În cazul unei nave cu propulsie clasică, la viteză \"full\" pescajul pupa",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) scade datorită cavitaţiei",
                "b) rămâne neschimbat, ca si cum nava ar staţiona",
                "c) creşte datorită cavitaţiei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "141. Calităţile etravei sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) robusteţea şi asigurarea rezistenţei navei la şocuri şi coliziuni minore, reducerea rezistenţei la înaintare",
                "b) să permită ieşirea etanşă a arborelui portelice",
                "c) să faciliteze depozitarea lanţului de ancoră"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "142. Etrava navei închide osatura compartimentului",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) after peak",
                "b) cofferdam maşini",
                "c) forepeak"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "143. Partea inferioară a etravei poate include",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tubul etambou",
                "b) pana cârmei",
                "c) bulbul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "144. Ce este etamboul unei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este elementul de construcţie care închide corpul navei la extremitatea pupa",
                "b) partea din faţa cuplului maestru, care cuprinde varangele şi chila de ruliu a unei nave",
                "c) compartimentul care separă camera cârmei de compartimentul maşină"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "145. Etamboul unei nave este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) partea din faţa cuplului maestru, care cuprinde varangele şi chila de ruliu a unei nave",
                "b) partea din prova, care protejeaza nava la şocuri şi coliziuni minore, reducerea rezistenţei la înaintare",
                "c) construcţia solidă şi etanşă situată la pupa navei şi care permite trecerea etanşă a axului portelice şi a axului cârmei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "146. Ce rol are etamboul unei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) închide corpul navei la pupa, permite trecerea etanşă a axului portelice şi a axului cârmei",
                "b) protejeaza nava de şocurile datorate coliziunilor uşoare din timpul înaintării prin apă",
                "c) adăposteşte puţul lanţului şi sonda ultrason"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "147. Forma etamboului depinde de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mărimea ancorelor",
                "b) forma şi mărimea elicei şi a penei cârmei",
                "c) poate fi proiectată oricum"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "148. Elementele de guvernare ale unei nave sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bulbul",
                "b) cârma, propulsoarele, bow thruster-ele",
                "c) chilele de ruliu"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "149. Duzele propulsoarelor navale pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) fixe sau pivotante",
                "b) în nici un caz nu se folosesc duze la propulsoarele navale",
                "c) numai fixe"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "150. Pana cârmei acţionează prin",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) devierea într-un bord a curentului de apă al elicei şi transmiterea reacţiei corpului navei, abătând pupa în sens opus acestei devieri",
                "b) devierea în jos a curentului de apă al elicei şi modificarea pescajului pupa al navei",
                "c) devierea în sus a curentului de apă al elicei şi creşterea pescajului pupa al navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "151. Funcţie de poziţionarea safranului cârmei faţă de axul acestuia, cârma unei nave poate fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) compensată sau necompensată",
                "b) semicompensată",
                "c) ambele cazuri anterioare"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "152. Cârma acţionată de o elice montată în safran se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cârmă cu troţe",
                "b) cârmă activă",
                "c) cârmă independentă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "153. Cârmele suspendate sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cârmele amplasate în borduri, la navele cu două sau mai multe cârme",
                "b) cârmele acţionate cu pompe hidraulice",
                "c) cârmele ale căror ax susţine pana pe verticală, fără a se sprijini pe un călcâi al prelungirii chilei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "154. Opera moartă a corpului unei nave are rolul de a",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) asigura un volum etanş care reprezintă rezerva de flotabilitate în condiţii deosebite de navigaţie",
                "b) suporta efectul curenţilor Foucault",
                "c) volumul etanş care asigură pescajul la linia de plină încărcare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "155. Efectul legii lui Arhimede se aplică",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) asupra operei vii a navei",
                "b) asupra operei moarte a navei",
                "c) asupra capacelor magaziilor de marfă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "156. Ce este secţiunea maestră?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este secţiunea vertical-transversală care trece prin mijlocul teoretic al navei, unde lăţimea este maximă",
                "b) este sectiunea vertical-longitudinală ce trece prin mijlocul navei",
                "c) secţiunea care trece prin planul liniei de bază şi defineşte pescajul maxim al navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "157. În cadrul osaturii navei, planşeul este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) construcţie metalică robustă care delimitează partea superioară a unei punţi",
                "b) o structură compusă dintr-o tablă (placă) rezemată pe un contur şi întărită printr-un sistem de grinzi",
                "c) construcţie întărită cu ajutorul elementelor de rezistenţă şi care formează punţile navelor"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "158. Ce rol are învelişul dublului fund?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) adăposteşte tancurile de balast superioare",
                "b) asigură nescufundabilitatea navei în caz de avariere a dublului fund",
                "c) adăposteşte agregatele mecanismelor de ridicat"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "159. Ce rol au planşeele din corpul unei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin structura lor, au rolul de a asigura sprijinirea coastelor navei",
                "b) fiind structuri de rezistenţă, asigură ambarcarea în condiţii de deplină siguranţă a mărfurilor lichide în vrac",
                "c) acestea preiau şi transmit osaturii navei sarcinile normale şi asigură rezistenţa corpului navei într-un anumit punct"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "160. Ce este gurna?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este porţiunea curbată de îmbinare a fundului plat cu bordajul navei",
                "b) este o carlingă ce uneşte foile dublului fund cu bulbul navei",
                "c) este partea de osatură care asigură fixarea catargelor navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "161. Care dintre următoarele elemente fac parte din osatura longitudinală a navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pereţii transversali şi traversele de fund",
                "b) longitudinalele de fund, de bordaj şi de punte",
                "c) catargele şi coloanele"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "162. Tancurile de balast au rolul de a",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) asigura rezerva de combustibil pentru un voiaj lung",
                "b) asigura accesul înspre magaziile de marfă, când nava nu este încărcată",
                "c) asigura stabilitatea în diferite cazuri de încărcare, de a regla asieta şi de a realiza deplasamentul de siguranţă în condiţia de balast"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "163. Ce sunt tancurile de balast?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) compartimente etanşe situate la nivelul punţii principale",
                "b) compartimente destinate depozitării mărfurilor generale containerizate",
                "c) compartimente etanşe situate sub puntea principală, la prova, la pupa, în borduri, la dublul fund, care au posibilitatea de a fi umplute cu şi golite de apă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "164. La o navă cu \"totul la pupa\", suprastructura de la prova navei, unde se află agregate şi instalaţii, se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) teuga",
                "b) roof central",
                "c) dunetă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "165. La o navă cu \"totul la pupa\", suprastructura de la centrul navei, unde se află agregate şi instalaţii, se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dunetă",
                "b) castel pupa",
                "c) roof central"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Constructia navei",
            "difficulty": 1
        },
        {
            "question": "166. Ce reprezintă vitalitatea navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) capacitatea navei de a pluti în condiţii de avarie",
                "b) capacitatea navei de a-şi menţine caracteristicile tehnice, de exploatare şi proprietăţile nautice în condiţii de avarie",
                "c) capacitatea navei de a-şi menţine caracteristicile tehnice, de exploatare şi proprietăţile nautice în condiţii normale de exploatare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "167. Supravieţuirea echipajului se defineşte ca fiind",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) capacitatea echipajului unei nave de a-şi asigura, prin utilizarea tuturor mijloacelor de la bordul navei, siguranţa şi integritatea fizică şi morală în condiţia de avarie a navei",
                "b) capacitatea echipajului unei nave de a putea procura hrană şi aprovizii în porturile de escală",
                "c) capacitatea echipajului de a asigura odihna de cel puţin 12 ore din 24, chiar în condiţia de avarie a navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "168. În condiţia de avarie a unei nave, trebuiesc menţinute funcţionale",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) instalaţia de aer condiţionat",
                "b) instalaţia depozitare şi tratare a resturilor menajere",
                "c) instalaţiile vitale ale navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "169. Cine reglementează dotarea navelor cu instalaţii şi mijloace pentru asigurarea vitalităţii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Societăţile de clasificare",
                "b) Sistemul de Management al Armatorului",
                "c) regulile York-Antwerp"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "170. Vitalitatea navei este suficient asigurată prin",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) realizarea construcţiei adecvate",
                "b) dotările tehnice în de ultimă generaţie în domeniu",
                "c) ambele variante anterioare plus activitatea profesionistă a echipajului"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "171. Compartimentarea navei se face în scopul",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) asigurării unei ventilaţii eficiente",
                "b) realizarea unei mai bune stabilităţi de drum",
                "c) asigurării nescufundabilităţii navei în cazul inundării accidentale şi izolării în caz de incendiu"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "172. Capacitatea echipajului unei nave de a-şi asigura, prin utilizarea tuturor mijloacelor de la bordul navei, siguranţa şi integritatea fizică şi morală în condiţia de avarie a navei reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) certificarea \"safe manning\" a navei",
                "b) vitalitatea echipajului",
                "c) nescufundabilitatea navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "173. Compartimentarea navei constă în",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prevederea amplasării capacelor magaziilor de marfă şi a sistemului de închidere etanşă a acestora",
                "b) asigurarea sistemului de umplere şi golire a tancurilor de balast",
                "c) Împărţirea prin construcţie a corpului navei în compartimente independente etanşe"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "174. Spaţiul dintre etrava navei şi primul perete transversal etanş se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) coferdam",
                "b) forepeak",
                "c) afterpeak"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "175. Spaţiul dintre ultimul perete transversal etanş şi etamboul navei se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) coferdam",
                "b) forepeak",
                "c) afterpeak"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "176. Ce este forepeak-ul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) spaţiul dintre ultimul perete transversal etanş şi etamboul navei",
                "b) spaţiul dintre etrava navei şi primul perete transversal etanş",
                "c) spaţiul dintre compartimentul maşină şi magazia sau magaziile de marfa a(le) navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "177. Cofferdam-urile au rolul de a",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) asigura depozitarea materialelor de avarie",
                "b) asigura depozitarea materialelor SOPEP",
                "c) separa şi proteja două compartimente adiacente, ale căror destinaţii sunt complet diferite"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "178. Partea corpului navei cea mai expusă unor avarii, este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova",
                "b) compartimentul maşină",
                "c) castelul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "179. Măsurile de menţinere a flotabilităţii navei avariate intră în categoria activităţii de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) telecomunicaţii de rutină",
                "b) mentenenţă programată",
                "c) asigurare a vitalităţii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "180. În scopul asigurării nescufundabilităţii navei se procedează constructiv la",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dotarea navei cu echipaj suplimentar",
                "b) compartimentarea corpului navei",
                "c) dotarea bărcilor de salvare cu motoare diesel cu pornire electrică"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "181. Pe lângă mijloacele pasive de vitalitate, nava mai dispune de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mijloace de folosinţă individuală",
                "b) mijloace de semnalizare \"om la apă\"",
                "c) mijloace active"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "182. Cea mai utilizată metodă nespecializată de prevenire a incendiilor la bordul navelor care transportă mărfuri periculoase este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) interzicerea fumatului în locuri nepermise, a lucrului cu flacără deschisă şi a utilizării sculelor metalice care pot produce scântei",
                "b) utilizarea gazului inert în compartimentele de locuit",
                "c) aplicarea de vopsele ignifuge pe culoarele din compartimentul maşină"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "183. Găurile de apă se caracterizează prin",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mărimea pescajului navei",
                "b) poziţie, dimensiune, aspect şi provenienţă",
                "c) mijloacele de astupare pretabile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "184. Din măsurile permanente de asigurare a nescufundabilităţii navei, face parte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) menţinerea permanentă a funcţionalităţii instalaţiilor şi a echipamentelor de vitalitate de la bordul navei",
                "b) asigurarea rezervelor de combustibil care să acopere autonomia maximă a navei",
                "c) asigurarea rezervelor de apă tehnică şi potabilă la full capacitate tancuri"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "185. O gaură de apă este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un orificiu practicat voluntar în borduri pentru scurgerea apei ambarcate pe punţi",
                "b) o decupare practicată în falsbordul teugii, prin care trec parâmele",
                "c) o perforare accidentală a corpului navei, cauzată de contactul involuntar cu un obiect dur fix, plutitor sau imers"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "186. Găurile de apă se pot clasifica după",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) provenienţă, dimensiuni şi aspect",
                "b) anotimp",
                "c) zona de navigaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "187. Găurile de apă se pot clasifica după",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tipul navei la care se găseşte",
                "b) dimensiuni şi poziţia acesteia faţă de linia de plutire",
                "c) lungimea între perpendiculare a navei în cauză"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "188. După provenienţă, găurile de apă pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) produse în urma unei coliziuni cu o altă navă",
                "b) deasupra liniei de plutire",
                "c) cu aspect neregulat"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "189. După provenienţă, găurile de apă pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sub linia de plutire",
                "b) cauzate de o eşuare",
                "c) cu aspect regulat dreptunghic"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "190. După provenienţă, găurile de apă pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în zona de alternanţă",
                "b) mici, mijlocii, mari şi foarte mari",
                "c) unei coliziuni cu cheul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "191. După dimensiuni, găurile de apă pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mici, mijlocii, mari şi foarte mari",
                "b) dreptunghiulare, triunghiulare sau neregulate",
                "c) cu aspect regulat rotund"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "192. După aspect, găurile de apă pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mici, mijlocii, mari şi foarte mari",
                "b) cauzate de o eşuare",
                "c) cu aspect regulat şi margini netede sau cu aspect neregulat şi margini deformate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "193. O gaură de apă produsă în urma coliziunii cu un corp aflat în imersiune, va fi poziţionată",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în opera moartă",
                "b) în puntea principală",
                "c) în carena navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "194. Inventarul de avarie al unei nave reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) totalitatea materialelor, echipamentelor şi dispozitivelor pentru combaterea avarierii corpului navei",
                "b) totalitatea mecanismelor de manevrare a capacelor de marfă",
                "c) instalaţiile complexe de condiţionare a aerului din cabinele de locuit şi cambuză"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "195. Inventarul de avarie al unei nave se compune din",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) scule de îndepărtarea ruginii",
                "b) scule de îndepărtare a vopselei vechi",
                "c) materialele, echipamentele şi dispozitivele pentru combaterea avarierii corpului navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "196. Din inventarul de avarie al unei nave fac parte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) paieturi",
                "b) hărţi metrice de navigaţie",
                "c) ramele bărcilor de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "197. Din inventarul de avarie al unei nave fac parte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dispozitive de amarare a butoaielor",
                "b) dispozitive de astupare a găurilor de apă",
                "c) documentaţia tehnică a instalaţiei de salvare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "198. Din inventarul de avarie al unei nave fac parte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) zincurile din casetele prizelor de suprafaţă",
                "b) grătarele de protecţie din coş",
                "c) plasturi cu margini moi"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "199. Din inventarul de avarie al unei nave fac parte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dulapi şi dopuri",
                "b) ustensilele de pescuit",
                "c) oglinzi metalice de semnalizare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "200. Din inventarul de avarie al unei nave fac parte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cleme şi întinzători",
                "b) sistemele de propulsie de la bărcile de salvare",
                "c) setul de documente de navigaţie din bărcile de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "201. Obiectele din inventarul de avarie sunt vopsite în roşu pentru",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) a putea fi uşor recunoscute",
                "b) aşa prevăd reglementările societăţii de clasificare",
                "c) aceste obiecte nu sunt vopsite în roşu"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Vitalitate",
            "difficulty": 1
        },
        {
            "question": "202. Obiectele din inventarul de avarie sunt vopsite în albastru pentru",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) aşa prevăd normele de protecţie a muncii",
                "b) a fi uşor recunoscute şi a nu fi utilizate în alte scopuri",
                "c) nu sunt vopsite în albastru"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Vitalitate",
            "difficulty": 1
        }
    ]
};
